import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const STORAGE_KEY = 'developerMode';

const loadFromStorage = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

interface DeveloperModeState {
  developerMode: boolean;
}

const initialState: DeveloperModeState = {
  developerMode: loadFromStorage(),
};

const developerModeSlice = createSlice({
  name: 'developerMode',
  initialState,
  reducers: {
    toggleDeveloperMode(state) {
      state.developerMode = !state.developerMode;
    },
    setDeveloperMode(state, action: PayloadAction<boolean>) {
      state.developerMode = action.payload;
    },
  },
});

export const { toggleDeveloperMode, setDeveloperMode } = developerModeSlice.actions;
export default developerModeSlice.reducer;
